import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Lock = _resolveComponent("Lock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.isManualDialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isManualDialogVisible) = $event)),
    "close-on-press-escape": "",
    "append-to-body": "",
    width: "30%",
    center: "",
    "body-class": "payout-order-manual-dialog__body",
    "footer-class": "payout-order-manual-dialog__footer",
    onClose: _ctx.closeDialog
  }, {
    header: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("h4", null, " Manual flow confirmation ", -1 /* CACHED */)
    ]))]),
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: _ctx.ComponentSize.SMALL,
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Cancel ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size", "onClick"]),
      _createVNode(_component_el_button, {
        size: _ctx.ComponentSize.SMALL,
        type: "success",
        disabled: _ctx.isModerationCommentEmpty,
        onClick: _ctx.takeManualFlowTransaction
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" Confirm ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["size", "disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_input, {
        modelValue: _ctx.moderationComment,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.moderationComment) = $event)),
        placeholder: "Please, enter your comment...",
        type: "textarea",
        clearable: "",
        autosize: { minRows: 6 }
      }, {
        prefix: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_Lock)
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue", "onClose"]))
}